import { BaseEditViewStore} from 'core/stores';
import { FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalForm } from 'application/facility-order-new-flow-us-intake/forms';
import { FacilityOrderTemplateService } from "application/facility-order/services";
import { action } from "mobx";

class FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalStore extends BaseEditViewStore {
    constructor(rootStore, componentProps) {
        const facilityOrderTemplate = componentProps.modalParams.data.facilityOrderTemplate;
        super(rootStore, {
            name: 'facility-order-template-us-intake-edit-clinical-status-note-modal',
            Form: FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalForm,
            id: facilityOrderTemplate ? facilityOrderTemplate.id : null,
            actions: () => {
                return {
                    get: async() =>{
                        return facilityOrderTemplate;
                    },
                    update: async() =>{
                        await this.facilityOrderTemplateService.updateClinicalStatusNote({id: this.id, clinicalStatusNote: this.form.$("clinicalStatusNote").value});
                    }
                }
            },
            FormClass: FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalForm
        });

        this.rootStore = rootStore;
        this.modalParams = componentProps.modalParams;
        this.facilityOrderTemplateService = new FacilityOrderTemplateService(rootStore.application.baasic.apiClient);
        this.facilityOrderTemplate = facilityOrderTemplate;
    }

    @action.bound
    async updateResource(resource) {
        if (!this.actions.update) return;

        this.form.setFieldsDisabled(true);
        try {
            if (this.translationStore) {
                this.translationStore.applyMetadata(resource);
            }
            this.facilityOrderTemplate.clinicalStatusNote = this.form.$("clinicalStatusNote").value;
            this.actions.update();
            await this.modalParams.close();
        }
        catch (err) {
            this.form.setFieldsDisabled(false);
            return this.onUpdateError(err);
        }
    }

    @action.bound
    notifySuccessUpdate(name) {
        this.rootStore.notificationStore.success('FACILITY_ORDER_NEW_FLOW.EDIT.TEMPLATE_NOTE.SUCCESS_UPDATE', name);
    }
}

export default FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalStore;
